import inputData from './inputData/client-satisfaction-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'client-satisfaction-survey',
  title: 'Client Satisfaction Survey',
  description: 'Check in with your clients and understand how satisfied they are with your services so you can keep improving.',
  image: '/images/templates/client-satisfaction-survey.png',
  tags: ['get-feedback', 'customer-success', 'product'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

